





















































import { defineComponent } from "@vue/composition-api";

export default defineComponent({
    setup() {
        const base = `${process.env.VUE_APP_IDENTITY_PROVIDER_DOMAIN}/content/walkthroughs`;
        const url = (filename: string) => `${base}/${encodeURIComponent(filename)}`;
        const coachingUrl = (filename: string) => `${base}/coaching-references/${encodeURIComponent(filename)}`;

        const launcherUrl = url("Arkansas Observation Tools - Launcher - Offline.html");
        const coachingIndexUrl = coachingUrl("Coaching References - Index - Offline.html");

        const walkthroughs = [
            {
                title: "TESS — Classroom Instruction",
                items: [
                    { name: "Classroom Observation — Section Tools", desc: "Section 1: Classroom Environment | Section 2: Student Learning & Instruction", url: url("Arkansas Observation - Section 1 & 2 Separate - Offline.html") }
                ]
            },
            {
                title: "TESS — Subject-Specific Key Levers",
                items: [
                    { name: "K-12 AR Mathematics Observation", desc: "K-12 Tier 1 & Intervention key levers: structure, aligned content, instructional practices, student practice, and assessment", url: url("K-12 AR Mathematics Observation (TESS) - Offline.html") },
                    { name: "Targeting Literacy Skills Observation", desc: "K–3 Tier 1 & Intervention; Science of Reading aligned", url: url("Targeting Literacy Skills Observation (TESS) - Offline.html") },
                    { name: "Foundational Science Observation", desc: "Science structures, instructional practices, student practice, and assessment", url: url("Foundational Science Observation (TESS) - Offline.html") }
                ]
            },
            {
                title: "LEADS — Building Leadership",
                items: [
                    { name: "Building Safety Observation — Safe & Orderly", desc: "LEADS Principal Rubric 2A", url: url("Building Safety Observation (LEADS 2A) - Offline.html") }
                ]
            }
        ];

        const coachingReferences = [
            {
                title: "TESS — Classroom Instruction",
                items: [
                    { name: "Classroom Observation Coaching Reference", desc: "Reinforcement for scores 3–4, Refinement for scores 1–2", url: coachingUrl("Classroom Observation Coaching Reference - Offline.html") }
                ]
            },
            {
                title: "TESS — Subject-Specific Key Levers",
                items: [
                    { name: "K-12 Mathematics Coaching Reference", desc: "Reinforcement for Yes, Refinement for No", url: coachingUrl("K-12 Mathematics Coaching Reference - Offline.html") },
                    { name: "Targeting Literacy Skills Coaching Reference", desc: "Reinforcement for Yes, Refinement for No", url: coachingUrl("Targeting Literacy Skills Coaching Reference - Offline.html") },
                    { name: "Foundational Science Coaching Reference", desc: "Reinforcement for Yes, Refinement for No", url: coachingUrl("Foundational Science Coaching Reference - Offline.html") }
                ]
            },
            {
                title: "LEADS — Building Leadership",
                items: [
                    { name: "Building Safety Coaching Reference", desc: "Reinforcement for a complete response; Refinement / Corrective Action otherwise", url: coachingUrl("Building Safety Coaching Reference - Offline.html") }
                ]
            }
        ];

        return { launcherUrl, walkthroughs, coachingIndexUrl, coachingReferences };
    }
});
